module.exports = __webpack_public_path__ + "media/dog-weight/staffie-white-5070a981.svg";